import { Outlet } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { CreateUserModal } from '@/components/CreateUserModal';
import { Navigation } from '@/components/HeaderNavigation';
import { isUserRetreivedAtom, userAtom } from '@/store/atoms';

export default function FarmersLayout() {
  const userRetreived = useAtomValue(isUserRetreivedAtom);
  const user = useAtomValue(userAtom);

  if (userRetreived && !user) {
    return <CreateUserModal />;
  }

  return (
    <div className="flex flex-col min-h-100vh overflow-hidden text-primary-black container pt-15-0 md:pt-8-0">
      <Navigation />
      {userRetreived && user && <Outlet />}
    </div>
  );
}
